<template>
  <div class="channel-detail-page" v-loading="loading">
    <template v-if="detail.channel && detail.channel.id">
      <div class="detail-header">
        <div class="detail-header__main">
          <h2>{{ detail.channel.nickname || `渠道 #${detail.channel.id}` }}</h2>
          <p>
            APP：{{
              detail.channel.app && detail.channel.app.app_name
                ? detail.channel.app.app_name
                : "--"
            }}
          </p>
        </div>
        <div class="detail-header__meta">
          <el-tag :type="Number(configForm.is_open) === 1 ? 'success' : 'info'">
            {{ Number(configForm.is_open) === 1 ? "开启" : "关闭" }}
          </el-tag>
          <el-tag effect="plain">渠道 ID：{{ detail.channel.id }}</el-tag>
        </div>
      </div>

      <el-tabs v-model="activeTab">
        <el-tab-pane label="主数据" name="base">
          <el-card shadow="never" class="detail-card">
            <el-form
              ref="baseFormRef"
              :model="baseForm"
              :rules="baseRules"
              label-width="120px"
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="渠道 ID">
                    <el-input :value="baseForm.id" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="APP ID">
                    <el-input :value="baseForm.app_id" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="渠道名称" prop="nickname">
                    <el-input v-model.trim="baseForm.nickname" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="APP 名称">
                    <el-input
                      :value="
                        detail.channel.app && detail.channel.app.app_name
                          ? detail.channel.app.app_name
                          : ''
                      "
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="APP 编码">
                    <el-input
                      :value="
                        detail.channel.app && detail.channel.app.app_code
                          ? detail.channel.app.app_code
                          : ''
                      "
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="创建时间">
                    <el-input
                      :value="$fnc.getTimeFormat(detail.channel.created_time, 'ymdhms')"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="更新时间">
                    <el-input
                      :value="$fnc.getTimeFormat(detail.channel.updated_time, 'ymdhms')"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div class="detail-actions">
              <el-button type="primary" :loading="baseSaving" @click="saveBase">
                保存主数据
              </el-button>
            </div>
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="渠道配置" name="config">
          <el-card shadow="never" class="detail-card">
            <div class="config-banner">
              当前保存的是渠道配置本身，不会影响 APP 基础配置。
            </div>
            <el-form :model="configForm" label-width="140px">
              <div class="config-section">
                <div class="config-section__title">奖励与投放</div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="佣金比例">
                      <el-input v-model.trim="configForm.amount_number" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="推荐比例">
                      <el-input
                        v-model.trim="configForm.recommend_number"
                        type="number"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最大广告数">
                      <el-input v-model.trim="configForm.max_ad" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最大 ECPM">
                      <el-input v-model.trim="configForm.max_money" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最小金额">
                      <el-input v-model.trim="configForm.min_amount" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最小金额数量">
                      <el-input
                        v-model.trim="configForm.min_amount_num"
                        type="number"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="config-section">
                <div class="config-section__title">下载与登录</div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="APK 地址">
                      <el-input v-model.trim="configForm.apk_url" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="渠道开关">
                      <el-select v-model="configForm.is_open" style="width: 100%">
                        <el-option label="开启" value="1" />
                        <el-option label="关闭" value="0" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="登录方式">
                      <el-select
                        v-model="configForm.login_type"
                        multiple
                        style="width: 100%"
                        placeholder="请选择登录方式"
                      >
                        <el-option label="微信登录" value="0" />
                        <el-option label="游客登录" value="1" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="config-section">
                <div class="config-section__title">时序控制</div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="关闭等待时间">
                      <el-input v-model.trim="configForm.close_time" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="拉起激励等待">
                      <el-input
                        v-model.trim="configForm.open_reward_time"
                        type="number"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="开屏超时时间">
                      <el-input v-model.trim="configForm.splash_time" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="红包打开间隔">
                      <el-input v-model.trim="configForm.open_time" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="信息流刷新间隔">
                      <el-input v-model.trim="configForm.info_time" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="插屏间隔">
                      <el-input
                        v-model.trim="configForm.interstitial_time"
                        type="number"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="开屏次数">
                      <el-input v-model.trim="configForm.splash_num" type="number" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="插屏次数">
                      <el-input
                        v-model.trim="configForm.interstitial_num"
                        type="number"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="插屏定时开关">
                      <el-select
                        v-model="configForm.Interstitial_open"
                        style="width: 100%"
                      >
                        <el-option label="开启" value="1" />
                        <el-option label="关闭" value="0" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>

            <div class="detail-actions">
              <el-button type="primary" :loading="configSaving" @click="saveConfig">
                保存渠道配置
              </el-button>
            </div>
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="渠道规则" name="rules">
          <el-card shadow="never" class="detail-card">
            <el-tabs v-model="ruleTab" class="rule-tabs">
              <el-tab-pane label="登录规则" name="1">
                <channel-rules :channel-id="channelId" type="1" />
              </el-tab-pane>
              <el-tab-pane label="拉广规则" name="2">
                <channel-rules :channel-id="channelId" type="2" />
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="定时风控" name="risk-task">
          <el-card shadow="never" class="detail-card">
            <div class="risk-task-summary">
              <div class="risk-task-summary__card">
                <div class="risk-task-summary__label">系统任务</div>
                <div class="risk-task-summary__value">
                  {{
                    detail.channel_risk_task && detail.channel_risk_task.name
                      ? detail.channel_risk_task.name
                      : "尚未自动创建"
                  }}
                </div>
                <div class="risk-task-summary__sub">
                  {{
                    detail.channel_risk_task
                      ? `状态：${formatTaskStatus(detail.channel_risk_task.status)}`
                      : "新增第一条策略后会自动创建"
                  }}
                </div>
              </div>

              <div class="risk-task-summary__card">
                <div class="risk-task-summary__label">系统调度器</div>
                <div class="risk-task-summary__value">
                  {{
                    detail.channel_risk_scheduler &&
                    detail.channel_risk_scheduler.name
                      ? detail.channel_risk_scheduler.name
                      : "尚未自动创建"
                  }}
                </div>
                <div class="risk-task-summary__sub">
                  {{
                    detail.channel_risk_scheduler
                      ? `模块：${detail.channel_risk_scheduler.handler_module || "--"}`
                      : "由系统自动生成"
                  }}
                </div>
              </div>

              <div class="risk-task-summary__card">
                <div class="risk-task-summary__label">最近运行</div>
                <div class="risk-task-summary__value">
                  {{
                    detail.channel_risk_latest_log
                      ? formatRunStatus(detail.channel_risk_latest_log.status)
                      : "暂无运行记录"
                  }}
                </div>
                <div class="risk-task-summary__sub">
                  {{
                    detail.channel_risk_latest_log &&
                    detail.channel_risk_latest_log.finished_at
                      ? formatTime(detail.channel_risk_latest_log.finished_at)
                      : "任务运行后会显示"
                  }}
                </div>
              </div>
            </div>

            <div class="risk-task-toolbar">
              <div class="risk-task-toolbar__hint">
                策略按渠道维护，系统任务和调度器由后端自动生成。
              </div>
              <el-button type="primary" size="mini" @click="openPolicyDialog()">
                新增策略
              </el-button>
            </div>

            <el-table
              :data="detail.channel_risk_policies || []"
              border
              stripe
              empty-text="暂无策略"
            >
              <el-table-column prop="name" label="策略名称" min-width="160" />
              <el-table-column label="策略类型" min-width="140" align="center">
                <template slot-scope="{ row }">
                  {{ getPolicyTypeLabel(row.policy_type) }}
                </template>
              </el-table-column>
              <el-table-column label="启用" width="90" align="center">
                <template slot-scope="{ row }">
                  <el-tag :type="Number(row.enabled) === 1 ? 'success' : 'info'">
                    {{ Number(row.enabled) === 1 ? "启用" : "停用" }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="priority" label="优先级" width="90" align="center" />
              <el-table-column label="参数摘要" min-width="240">
                <template slot-scope="{ row }">
                  {{ getPolicyConfigSummary(row) }}
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注" min-width="180" />
              <el-table-column label="操作" width="150" align="center" fixed="right">
                <template slot-scope="{ row }">
                  <el-button type="primary" size="mini" @click="openPolicyDialog(row)">
                    编辑
                  </el-button>
                  <el-button type="danger" size="mini" @click="deletePolicy(row)">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="渠道用户" name="users">
          <el-card shadow="never" class="detail-card">
            <channel-users :channel-id="channelId" />
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </template>

    <el-dialog
      :title="editingPolicy ? '编辑风控策略' : '新增风控策略'"
      :visible.sync="policyDialogVisible"
      width="760px"
      @closed="resetPolicyDialog"
    >
      <el-form
        ref="policyFormRef"
        :model="policyForm"
        :rules="policyRules"
        label-width="120px"
        size="small"
      >
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="策略类型" prop="policy_type">
              <el-select
                v-model="policyForm.policy_type"
                placeholder="请选择策略类型"
                style="width: 100%"
                :disabled="editingPolicy"
                @change="handlePolicyTypeChange"
              >
                <el-option
                  v-for="item in policyTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="策略名称" prop="name">
              <el-input
                v-model.trim="policyForm.name"
                placeholder="请输入策略名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否启用" prop="enabled">
              <el-switch
                v-model="policyForm.enabled"
                :active-value="1"
                :inactive-value="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优先级" prop="priority">
              <el-input-number
                v-model="policyForm.priority"
                :min="0"
                :max="9999"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <template v-if="currentPolicySchema">
          <div
            v-for="section in currentPolicySchema.sections || []"
            :key="section.title"
            class="policy-section"
          >
            <div class="policy-section__title">{{ section.title }}</div>
            <el-row :gutter="16">
              <el-col
                v-for="field in section.fields || []"
                v-show="shouldShowPolicyField(field, policyForm.policy_config)"
                :key="field.key"
                :span="12"
              >
                <el-form-item
                  :label="field.label"
                  :prop="`policy_config.${field.key}`"
                  :rules="buildDynamicFieldRules(field)"
                >
                  <el-input
                    v-if="field.type === 'input'"
                    v-model="policyForm.policy_config[field.key]"
                    :placeholder="field.placeholder || `请输入${field.label}`"
                  />
                  <el-input-number
                    v-else-if="field.type === 'number'"
                    v-model="policyForm.policy_config[field.key]"
                    :min="field.min !== undefined ? field.min : 0"
                    :max="field.max !== undefined ? field.max : 99999999"
                    style="width: 100%"
                  />
                  <el-select
                    v-else-if="field.type === 'select'"
                    v-model="policyForm.policy_config[field.key]"
                    style="width: 100%"
                    :placeholder="field.placeholder || `请选择${field.label}`"
                  >
                    <el-option
                      v-for="option in field.options || []"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"
                    />
                  </el-select>
                  <el-switch
                    v-else-if="field.type === 'switch'"
                    v-model="policyForm.policy_config[field.key]"
                    :active-value="1"
                    :inactive-value="0"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </template>

        <el-form-item label="备注" prop="remark">
          <el-input
            v-model.trim="policyForm.remark"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="policyDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="policySaving" @click="savePolicy">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ChannelRules from "@/components/app/components/Rules.vue";
import ChannelUsers from "@/components/app/components/UserAd.vue";
import {
  getPolicyConfigSummary,
  getPolicyTypeLabel,
  getTaskRunStatusLabel,
  mergePolicyDefaultConfig,
  normalizePolicyConfigValue,
  shouldShowPolicyField,
} from "@/utils/riskTask";

const defaultConfigForm = () => ({
  close_time: "",
  open_reward_time: "",
  max_ad: "",
  amount_number: "",
  recommend_number: "",
  apk_url: "",
  is_open: "0",
  splash_time: "",
  open_time: "",
  login_type: [],
  min_amount: "",
  min_amount_num: "",
  max_money: "",
  interstitial_time: "",
  Interstitial_open: "0",
  info_time: "",
  splash_num: "",
  interstitial_num: "",
});

const defaultPolicyForm = (channelId = "") => ({
  id: "",
  channel_id: channelId,
  policy_type: "",
  name: "",
  enabled: 1,
  priority: 100,
  remark: "",
  policy_config: {},
});

export default {
  components: {
    ChannelRules,
    ChannelUsers,
  },
  data() {
    return {
      loading: false,
      baseSaving: false,
      configSaving: false,
      policySaving: false,
      policyDialogVisible: false,
      editingPolicy: false,
      activeTab: "base",
      ruleTab: "1",
      policyOptionsMeta: {
        policy_types: [],
        form_schemas: {},
      },
      detail: {
        channel: null,
        channel_config: null,
        channel_rules: [],
        channel_risk_policies: [],
        channel_risk_task: null,
        channel_risk_scheduler: null,
        channel_risk_latest_log: null,
      },
      baseForm: {
        id: "",
        app_id: "",
        nickname: "",
      },
      configForm: defaultConfigForm(),
      policyForm: defaultPolicyForm(),
      baseRules: {
        nickname: [{ required: true, message: "请输入渠道名称", trigger: "blur" }],
      },
      policyRules: {
        policy_type: [{ required: true, message: "请选择策略类型", trigger: "change" }],
        name: [{ required: true, message: "请输入策略名称", trigger: "blur" }],
        priority: [{ required: true, message: "请输入优先级", trigger: "change" }],
      },
    };
  },
  computed: {
    channelId() {
      return this.$route.query.id || "";
    },
    policyTypeOptions() {
      return this.policyOptionsMeta.policy_types || [];
    },
    currentPolicyMeta() {
      return this.policyOptionsMeta.form_schemas[this.policyForm.policy_type] || null;
    },
    currentPolicySchema() {
      return this.currentPolicyMeta ? this.currentPolicyMeta.form_schema : null;
    },
  },
  methods: {
    getPolicyTypeLabel,
    getPolicyConfigSummary,
    shouldShowPolicyField,
    fillForms(data = {}) {
      const channel = data.channel || {};
      const channelConfig = data.channel_config || {};

      this.detail = {
        channel,
        channel_config: channelConfig,
        channel_rules: Array.isArray(data.channel_rules) ? data.channel_rules : [],
        channel_risk_policies: Array.isArray(data.channel_risk_policies)
          ? data.channel_risk_policies
          : [],
        channel_risk_task: data.channel_risk_task || null,
        channel_risk_scheduler: data.channel_risk_scheduler || null,
        channel_risk_latest_log: data.channel_risk_latest_log || null,
      };

      this.baseForm = {
        id: channel.id || "",
        app_id: channel.app_id || "",
        nickname: channel.nickname || "",
      };

      this.configForm = {
        ...defaultConfigForm(),
        ...channelConfig,
        login_type:
          channelConfig.login_type !== undefined &&
          channelConfig.login_type !== null &&
          channelConfig.login_type !== ""
            ? String(channelConfig.login_type)
                .split("@")
                .filter(Boolean)
            : [],
      };
    },
    formatTime(value) {
      return value ? this.$fnc.getTimeFormat(value, "ymdhms") : "--";
    },
    formatTaskStatus(status) {
      return getTaskRunStatusLabel(status);
    },
    formatRunStatus(status) {
      return getTaskRunStatusLabel(status);
    },
    async getPolicyOptions() {
      const data = await this.$api.getChannel.getChannelRiskPolicyOptions();
      this.policyOptionsMeta = data.data || {
        policy_types: [],
        form_schemas: {},
      };
    },
    async getInfo() {
      this.loading = true;
      try {
        const data = await this.$api.getChannel.getChannelInfo({
          id: this.channelId,
        });
        this.fillForms(data.data || {});
      } finally {
        this.loading = false;
      }
    },
    async saveBase() {
      const valid = await new Promise((resolve) => {
        this.$refs.baseFormRef.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      this.baseSaving = true;
      try {
        const data = await this.$api.getChannel.saveChannel({
          id: this.baseForm.id,
          nickname: this.baseForm.nickname,
        });
        if (data.code === 200) {
          this.$message.success("渠道主数据保存成功");
          this.getInfo();
        }
      } finally {
        this.baseSaving = false;
      }
    },
    normalizeConfigPayload() {
      return {
        id: this.channelId,
        close_time: this.configForm.close_time,
        open_reward_time: this.configForm.open_reward_time,
        max_ad: this.configForm.max_ad,
        amount_number: this.configForm.amount_number,
        recommend_number: this.configForm.recommend_number,
        apk_url: this.configForm.apk_url,
        is_open: this.configForm.is_open,
        splash_time: this.configForm.splash_time,
        open_time: this.configForm.open_time,
        login_type: Array.isArray(this.configForm.login_type)
          ? this.configForm.login_type.join("@")
          : "",
        min_amount: this.configForm.min_amount,
        min_amount_num: this.configForm.min_amount_num,
        max_money: this.configForm.max_money,
        interstitial_time: this.configForm.interstitial_time,
        Interstitial_open: this.configForm.Interstitial_open,
        info_time: this.configForm.info_time,
        splash_num: this.configForm.splash_num,
        interstitial_num: this.configForm.interstitial_num,
      };
    },
    async saveConfig() {
      this.configSaving = true;
      try {
        const data = await this.$api.getChannel.saveChannelConfig(
          this.normalizeConfigPayload()
        );
        if (data.code === 200) {
          this.$message.success("渠道配置保存成功");
          this.fillForms({
            ...this.detail,
            channel_config: data.data || {},
          });
        }
      } finally {
        this.configSaving = false;
      }
    },
    handlePolicyTypeChange(policyType) {
      const meta = this.policyOptionsMeta.form_schemas[policyType] || {};
      this.policyForm.policy_config = mergePolicyDefaultConfig(
        meta.default_config || {},
        {}
      );
    },
    openPolicyDialog(policy) {
      this.editingPolicy = Boolean(policy && policy.id);
      const policyType = policy && policy.policy_type ? policy.policy_type : "";
      const meta = this.policyOptionsMeta.form_schemas[policyType] || {};
      this.policyForm = {
        ...defaultPolicyForm(this.channelId),
        ...(policy || {}),
        channel_id: this.channelId,
        policy_type: policyType,
        policy_config: mergePolicyDefaultConfig(
          meta.default_config || {},
          policy && policy.policy_config ? policy.policy_config : {}
        ),
      };
      this.policyDialogVisible = true;
    },
    resetPolicyDialog() {
      this.policyForm = defaultPolicyForm(this.channelId);
      this.editingPolicy = false;
      if (this.$refs.policyFormRef) {
        this.$refs.policyFormRef.resetFields();
      }
    },
    buildDynamicFieldRules(field) {
      return [
        {
          validator: (rule, value, callback) => {
            if (!shouldShowPolicyField(field, this.policyForm.policy_config)) {
              callback();
              return;
            }
            if (field.required && (value === undefined || value === null || value === "")) {
              callback(new Error(`请输入${field.label}`));
              return;
            }
            if (field.type === "number" && value !== undefined && value !== null && value !== "") {
              const numericValue = Number(value);
              if (Number.isNaN(numericValue)) {
                callback(new Error(`${field.label}必须是数字`));
                return;
              }
              if (field.min !== undefined && numericValue < field.min) {
                callback(new Error(`${field.label}不能小于${field.min}`));
                return;
              }
              if (field.max !== undefined && numericValue > field.max) {
                callback(new Error(`${field.label}不能大于${field.max}`));
                return;
              }
            }
            callback();
          },
          trigger: "change",
        },
      ];
    },
    normalizePolicyPayload() {
      const normalizedConfig = {};
      const sections = (this.currentPolicySchema && this.currentPolicySchema.sections) || [];
      sections.forEach((section) => {
        (section.fields || []).forEach((field) => {
          normalizedConfig[field.key] = normalizePolicyConfigValue(
            field,
            this.policyForm.policy_config[field.key]
          );
        });
      });

      return {
        id: this.policyForm.id,
        channel_id: this.channelId,
        policy_type: this.policyForm.policy_type,
        name: this.policyForm.name,
        enabled: this.policyForm.enabled,
        priority: this.policyForm.priority,
        remark: this.policyForm.remark,
        policy_config: normalizedConfig,
      };
    },
    async savePolicy() {
      const valid = await new Promise((resolve) => {
        this.$refs.policyFormRef.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      this.policySaving = true;
      try {
        const payload = this.normalizePolicyPayload();
        const data = this.editingPolicy
          ? await this.$api.getChannel.saveChannelRiskPolicy(payload)
          : await this.$api.getChannel.addChannelRiskPolicy(payload);
        if (data.code === 200) {
          this.$message.success(this.editingPolicy ? "策略更新成功" : "策略新增成功");
          this.policyDialogVisible = false;
          await this.getInfo();
        }
      } finally {
        this.policySaving = false;
      }
    },
    deletePolicy(policy) {
      this.$confirm(`确定删除策略“${policy.name}”吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const data = await this.$api.getChannel.deleteChannelRiskPolicy({
            id: policy.id,
          });
          if (data.code === 200) {
            this.$message.success("策略删除成功");
            await this.getInfo();
          }
        })
        .catch(() => {});
    },
  },
  async created() {
    await this.getPolicyOptions();
    await this.getInfo();
  },
};
</script>

<style lang="less" scoped>
.channel-detail-page {
  min-height: 420px;
}

.detail-header {
  margin-bottom: 18px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 18px;
  background: linear-gradient(135deg, #f7fbff, #eef5ff);
  border: 1px solid #dde8f8;
}

.detail-header__main {
  h2 {
    margin: 0;
    color: #203864;
    font-size: 24px;
  }

  p {
    margin: 8px 0 0;
    color: #7a8da9;
  }
}

.detail-header__meta {
  display: flex;
  gap: 10px;
}

.detail-card {
  border-radius: 18px;
}

.detail-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.config-banner {
  margin-bottom: 18px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fdf6ec;
  border: 1px solid #f3d19e;
  color: #a46c18;
  font-size: 13px;
}

.config-section {
  & + & {
    margin-top: 18px;
    padding-top: 18px;
    border-top: 1px dashed #d9e4f3;
  }
}

.config-section__title,
.policy-section__title {
  margin-bottom: 14px;
  font-size: 15px;
  font-weight: 600;
  color: #1f4ea0;
}

.risk-task-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.risk-task-summary__card {
  padding: 16px;
  border-radius: 14px;
  background: #f7fbff;
  border: 1px solid #dde8f8;
}

.risk-task-summary__label {
  color: #6f84a8;
  font-size: 13px;
}

.risk-task-summary__value {
  margin-top: 10px;
  color: #203864;
  font-size: 17px;
  font-weight: 600;
  word-break: break-word;
}

.risk-task-summary__sub {
  margin-top: 10px;
  color: #7a8da9;
  font-size: 12px;
  line-height: 1.6;
}

.risk-task-toolbar {
  margin: 18px 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.risk-task-toolbar__hint {
  color: #6f84a8;
  font-size: 13px;
}

.policy-section {
  & + & {
    margin-top: 12px;
  }
}
</style>
